import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import creator1 from "../assets/img/creator/1.png";
import creator2 from "../assets/img/creator/2.png";
import creator3 from "../assets/img/creator/3.png";
import creator4 from "../assets/img/creator/4.png";
import creator5 from "../assets/img/creator/5.png";
import creator6 from "../assets/img/creator/6.png";

// Import images

const CreatorSlider = () => {
     const navigate = useNavigate();
      const [roleList, setRoleList] = useState([]);
  
      useEffect(() => {
          fetchRoles();
      }, []);
  
      const fetchRoles = async () => {
          try {
              const response = await axios.get(`${API_BASE_URL}/getCollegeLogoMediaFile`, {
                  headers: {
                      "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                      "Content-Type": "application/json",
                  },
              });
              setRoleList(response.data);
          } catch (err) {
              console.error("Error fetching roles:", err);
          }
      };
  return (
    <div className="institute-slider-container partner-slider">
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 2 },
            600: { items: 4 },
            1000: { items: 6 },
          }}
        >
          {/* <div class="text-center">
            <img src={creator1} alt="thumb" />
            <h6 class="pt-2">University</h6>
          </div>
          <div class="text-center">
            <img src={creator2} alt="thumb" />
            <h6 class="pt-2">National College</h6>
          </div>
          <div class="text-center">
            <img src={creator3} alt="thumb" />
            <h6 class="pt-2">AIMT</h6>
          </div>
          <div class="text-center">
            <img src={creator4} alt="thumb" />
            <h6 class="pt-2">ATOAE</h6>
          </div>
          <div class="text-center">
            <img src={creator5} alt="thumb" />
            <h6 class="pt-2">No Name</h6>
          </div>
          <div class="text-center">
            <img src={creator6} alt="thumb" />
            <h6 class="pt-2">IIT Gandhinagar</h6>
          </div> */}
           {roleList.map((expert) => (
                      <div class="text-center" key={expert.id}>
                        <div className="institute-card course-img">
                          <img
                            src={`${Image_Base_Url}${expert.media_image_path}`}
                           alt="thumb"
                           style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                            borderRadius: "10px",
                          }}
                          
                          />
                         <h6 class="pt-2">{expert.name}</h6>
                        </div>
                      </div>
                    ))}


        </OwlCarousel>
    </div>
  );
};

export default CreatorSlider;